import { useMemo, useState } from "react";
function useSimpleSelect(props) {
  const { onBlur, onFocus, MenuProps: providedMenuProps, defaultOpen, onMouseEnter, onMouseLeave } = props;
  const [open, setOpen] = useState(() => defaultOpen ?? false);
  const [focused, setFocused] = useState(false);
  const [mouseIn, setMouseIn] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setFocused(false);
    setMouseIn(false);
  };
  const handleToggleOpen = () => {
    if (open) {
      setFocused(false);
      setMouseIn(false);
    }
    setOpen((prev) => !prev);
  };
  const handleOnFocus = (event) => {
    setFocused(true);
    onFocus?.(event);
  };
  const handleOnBlur = (event) => {
    const isClearBtn = event.relatedTarget?.dataset?.id === "clear-btn";
    if (!isClearBtn) setFocused(false);
    onBlur?.(event);
  };
  const handleOnMouseEnter = (event) => {
    setMouseIn(true);
    onMouseEnter?.(event);
  };
  const handleOnMouseLeave = (event) => {
    setMouseIn(false);
    onMouseLeave?.(event);
  };
  const MenuProps = useMemo(
    () => ({
      "data-testid": "select-option-container",
      ...providedMenuProps
    }),
    [providedMenuProps]
  );
  return {
    open,
    focused,
    mouseIn,
    MenuProps,
    handleOpen,
    handleClose,
    handleOnBlur,
    handleOnFocus,
    handleToggleOpen,
    handleOnMouseEnter,
    handleOnMouseLeave
  };
}
export {
  useSimpleSelect
};
//# sourceMappingURL=useSimpleSelect.js.map
